import React, { Component, Fragment, PureComponent } from 'react';
import ReactDOM from 'react-dom';
import { inject, observer } from 'mobx-react';
import { numberFormat } from '../../common';
import Message from './message';
import Win from './win';
import Systems from './systems';
import Selecter from './selector';
import Odds from './items';
import Settings from './settings';
import FastAmount from './fastAmount';
import OneClick from './oneClick';
import onClickOutside from 'react-onclickoutside';
import { get } from 'lodash';
@inject('dictStore', 'lineStore')
@observer
class Label extends Component {
  render() {
    const basketData = this.props.lineStore.basket.basketData
    const odds = get(basketData, 'odds', {})
    const oddsLength = Object.keys(odds).length

    return (
      <div className="basket-header-label-new">
        <div className="basket-bets-count-item basket-bets-count-item-border">
          <span className="fl_l">{this.props.dictStore.getLang('BASKET')}</span>
          {oddsLength > 0 ? <span className="fl_r basket-count-bet">{oddsLength}</span> : ''}
        </div>
        <div className="basket-bets-count-item b-b-c-i">
          <span className="fl_l">{this.props.dictStore.getLang('BETS')}</span>
        </div>
      </div>
    );
  }
}

@inject('lineStore', 'dictStore')
@observer
class Switcher extends Component {

  handleOneClick = () => {
    const basketData = this.props.lineStore.basket.basketData
    const isBetOneClick = get(basketData, 'isBetOneClick')
    this.props.lineStore.basket.newSetIsBetOneClick(!isBetOneClick);
  };

  render() {
    const basketData = this.props.lineStore.basket.basketData
    const isBetOneClick = get(basketData, 'isBetOneClick')

    const { getLang } = this.props.dictStore;
    return (
      <Fragment>
        <div className="basket-row">
          <div className="clearfix">
            <div className={`checkbox fl_l ${isBetOneClick ? 'on' : ''}`} onClick={this.handleOneClick}>
              <span></span>
              <label className="">{getLang('BASKET_ONE_CLICK_BET')}</label>
            </div>
          </div>
        </div>
        <div className="basket-circles"></div>
      </Fragment>
    );
  }
}

@inject('lineStore', 'dictStore', 'appStore', 'accountStore')
@onClickOutside
@observer
export default class Basket extends Component {

  headRef = React.createRef();
  footerRef = React.createRef();

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleDoBetEnter, false);
  }

  componentDidMount() {
    document.addEventListener('keyup', this.handleDoBetEnter, false);
  }

  handleDoBetEnter = (e) => {
    if (e.keyCode == 13) {
      this.props.lineStore.basket.newBasketDoBetRequest();
    }
  };

  handleClickOutside(evt) {
    // refactc
    if (evt.path && evt.path[0].className && !(evt.path[0].className.trim() == 'g-b' || evt.path[0].className.trim() == 'basket-bets-lurk' || evt.path[0].className.trim() == 'f-s-ico-arrow_buttom_1' || /ui-keyboard/.test(evt.path[0].className.trim()))) this.props.lineStore.basket.hideBasket();
  }

  handleClear = () => {
    this.props.lineStore.basket.newClearBasketAfterBet();
  };

  handleDoBet = () => {
    const basketData = this.props.lineStore.basket.basketData;
    const isBetRequestLoading = get(basketData, 'isBetRequestLoading')
    const disableDoBetButton = get(basketData, 'disableDoBetButton')
    if(isBetRequestLoading || disableDoBetButton) {
      return null
    }
    this.props.lineStore.basket.newBasketDoBetRequest();
  };

  render() {
    const { type, error, mode, oneClick, isLocked, success, toogleBasket, maxHeight, basketData } = this.props.lineStore.basket;

    if (!basketData) {
      return null
    }

    const disableDoBetButton = get(basketData, 'disableDoBetButton')
    const isBetOneClick = get(basketData, 'isBetOneClick')
    const isBetRequestLoading = get(basketData, 'isBetRequestLoading')
    const oddsIds = get(basketData, 'oddsIds', new Set())
    const betType = get(basketData, 'betType', 1)
    const odds = get(basketData, 'odds', {})
    const succesExpressAndSystemMessage = get(basketData, 'succesExpressAndSystemMessage')
    const globalError = get(basketData, 'globalError')
    const { getLang } = this.props.dictStore;

    return (
      <Fragment>
        <div className={`line-right-column-basket-cont b-l${!toogleBasket.showBasket ? ' hidden' : ''}`} id="basket-container">
          <div className="basket basket-right">
            <div className="basket-header" id="basket-header" ref={this.headRef}>
              {mode == 'live' ? <Switcher /> : ''}
              {isBetOneClick ? <OneClick /> : <Selecter />}
              <div className="basket-circles"></div>
              {basketData.globalError ? <Message /> : ''}
              <div className="basket-circles"></div>
            </div>
            <div className="basket-content" style={{ maxHeight: maxHeight + 'px' }}>
              {oddsIds.size && !isBetOneClick ? <Odds odds={odds} oddsIds={oddsIds} /> : ''}
              {basketData.succesExpressAndSystemMessage && betType !== 1 ? (
                <div className="basket-dobet-success">{getLang(basketData.succesExpressAndSystemMessage)}</div>
              ) : (
                ''
              )}
            </div>
            <div className="basket-footer" id="basket-footer" ref={this.footerRef}>
              {!isBetOneClick ?
                <Fragment>
                  <div className="basket-circles"></div>
                  {oddsIds.size ? <div className="basket-bets-icon-delete" onClick={this.handleClear}>
                    <div className="sport_i delete_icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 191 224">
                        <polygon points="112 15 112 0 80 0 80 15 0 15 0 48 191 48 191 15 112 15"></polygon>
                        <polygon points="143 191 48 191 48 64 15 64 15 224 16 224 48 224 143 224 176 224 176 191 176 64 143 64 143 191"></polygon>
                      </svg>
                    </div>
                    <div className="basket-bets-delete-text">
                      {getLang('CLEAR_BASKET')}
                    </div>
                  </div> : ''}
                  <div className="basket-circles"></div>
                  {oddsIds.size > 0 ? <Win /> : ''}
                  {oddsIds.size ? <FastAmount /> : ''}
                  <div className="basket-circles"></div>
                  <div className="basket-row basket-make-bet">
                    <div className="basket-buttons">
                      <button type="button" tabIndex="2" className={`flat_button basket-dobet basket-make-bet-button ${isBetRequestLoading ? 'wait' : ''}`}
                        onClick={this.handleDoBet} disabled={disableDoBetButton || isBetRequestLoading}>
                        {getLang('MAKE_BET')}
                      </button>
                    </div>
                  </div>
                  <div className="basket-circles"></div>
                  {betType == 3 ? <Systems /> : ''}
                </Fragment>
                : ''}
              <Settings />
            </div>
          </div>
        </div>
        <div className="line-bets-done"></div>
      </Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/basket/basket.js